<template>
    <div class="not-found">
      <h1>404</h1>
      <p>Oops! The page you're looking for doesn't exist.</p>
      <RouterLink to="/" class="home-button">Go Home</RouterLink>
    </div>
  </template>
  
  <script setup>
  </script>
  
  <style scoped>
  .not-found {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    text-align: center;
    background-color: #f8f9fa;
    color: #333;
  }
  
  h1 {
    font-size: 6rem;
    font-weight: bold;
    margin-bottom: 10px;
    color: #0099FC;
  }
  
  p {
    font-size: 1.5rem;
    margin-bottom: 20px;
  }
  
  .home-button {
    padding: 10px 20px;
    font-size: 1.2rem;
    text-decoration: none;
    background-color: #0099FC;
    color: #fff;
    border-radius: 5px;
    transition: background 0.3s;
  }
  
  .home-button:hover {
    background-color: #007acc;
  }
  </style>